// extracted by mini-css-extract-plugin
export default {"input":"styles_input__G7aFy","error":"styles_error__CWkxD"};